import { useState } from 'react';
import { Button, Card, Col, Form, Input, message, Row, Select, Space, Spin, Typography, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

import ErrorHandler from '../../utils/ErrorHandler';
import Notification from '../../components/controls/Notification';
import { CaseStudyAPI } from '../../utils/Api';
import { modalityList } from '../../utils/Constants';

const { Title } = Typography;
const { Option } = Select;

const CreateCaseStudy = () => {
  const [form] = Form.useForm();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [showSeriesUploadCard, setShowSeriesUploadCard] = useState(false);
  const [dicomCollections, setDicomCollections] = useState('');

  const handleResetFields = () => {
    form.resetFields();
    setDicomCollections('');
  };

  const onFinish = (value) => {
    setLoading(true);
    const body = {
      hpi: value.hpi,
      vitals: value.vital,
      labs: value.labs,
      modality: value.modality,
    };

    CaseStudyAPI.post('/question', body, { headers: { Authorization: `Bearer ${localStorage.getItem('at')}` } })
      .then((res) => {
        sessionStorage.setItem('qi', res.data.data.id);
        message.success('Please upload series files');
        setShowSeriesUploadCard(true);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ErrorHandler(err?.response?.data?.message, history);
        } else {
          Notification('Something went wrong! Please try again later', 'error');
        }
      })
      .finally(() => setLoading(false));
  };

  const handleDicomUpload = () => {
    if (dicomCollections.length > 0) {
      let formData = new FormData();

      for (const key of Object.keys(dicomCollections)) {
        formData.append('dicom', dicomCollections[key]);
      }

      setLoading(true);
      CaseStudyAPI.post(`/question/dicom/${sessionStorage.getItem('qi')}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('at')}`,
        },
      })
        .then(() => {
          Notification('Series uploaded successfully!', 'success');
          setDicomCollections('');
        })
        .catch((err) => {
          Notification('Error', err, 'error');
        })
        .finally(() => setLoading(false));
    } else {
      message.warning('Please add dicom collection');
    }
  };

  return (
    <Spin spinning={loading}>
      <div className='center'>
        <Title level={3}>Create Case Study</Title>
      </div>
      <Card className='mb-1'>
        <Form form={form} layout='vertical' onFinish={onFinish}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={12}>
              <Form.Item name='hpi' label='History of Present Illness' rules={[{ required: true, message: 'Please select HPI' }]}>
                <Input placeholder='10 year old boy with testicular pain' />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <Form.Item name='vital' label='Vital' rules={[{ required: true, message: 'Please select vital' }]}>
                <Input placeholder='Tachycardia to 120' />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <Form.Item name='labs' label='Labs' rules={[{ required: true, message: 'Please select labs' }]}>
                <Input placeholder='UA with 5 WBCs/HPF' />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <Form.Item name='modality' label='Modality' rules={[{ required: true, message: 'Please select modality' }]}>
                <Select>
                  {modalityList.map((el) => (
                    <Option key={el} value={el}>
                      {el}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row justify='center'>
            <Space size='middle'>
              <Button type='primary' htmlType='submit'>
                Next
              </Button>
              <Button onClick={handleResetFields}>Add another case</Button>
            </Space>
          </Row>
        </Form>
      </Card>

      {showSeriesUploadCard && (
        <Card>
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <input type='file' name='imgCollection' onChange={(e) => setDicomCollections(e.target.files)} multiple />
            </Col>
            {dicomCollections !== '' && (
              <Col xs={24}>
                <Button onClick={handleDicomUpload} icon={<UploadOutlined />}>
                  Upload Series
                </Button>
              </Col>
            )}
          </Row>
        </Card>
      )}
    </Spin>
  );
};

export default CreateCaseStudy;
